import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  This tool provides a levy estimate only. Levy estimates only apply for land where the levy has not yet been assessed. Land that has been assessed and has a payment status of ‘payment pending’, ‘staged payment’ or ‘paid’ will not return an estimate. We do not adjust levy assessments if a cadastre boundary realignment (since the original assessment) results in an unpaid portion of land. 
    </p>
    <p>
  If the payment status is ‘staged payment’, the land is currently subject to strict payment conditions under a staged payment approval. Please contact{' '} <InlineLink href="mailto:msa.habitatcompensation@delwp.vic.gov.au" text="msa.habitatcompensation@delwp.vic.gov.au" mdxType="InlineLink" /> for further information.
    </p>
    <p>
  To review areas covered by existing or pending levy payments, refer to the MSA Payment Status layer on the map.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      